import { focusManager, QueryClient, QueryClientProvider as QueryClientProviderOriginal } from "@tanstack/react-query";
import { AppState, Platform } from "react-native";

// Native: 'focus' is de app die weer actief wordt. Op web luistert react-query
// zelf naar visibilitychange. Queries met refetchOnWindowFocus verversen dan
// alleen als hun staleTime verlopen is.
if (Platform.OS !== "web") {
  focusManager.setEventListener((handleFocus) => {
    const subscription = AppState.addEventListener("change", (state) => handleFocus(state === "active"));
    return () => subscription.remove();
  });
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      throwOnError: (_error, query) => query.state.data === undefined,
      retry: 2,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
      // onError: (err: any) => {
      //   const isString = typeof err?.message === "string";
      //   toast.show(isString ? err?.message : "Er ging iets fout");
      // },
    },
  },
});

export default function QueryClientProvider({ children }: { children: any }) {
  return <QueryClientProviderOriginal client={queryClient}>{children}</QueryClientProviderOriginal>;
}
